import store_laboratoire from '@/store/mods/analyses/laboratoire'
import { date_heure_zone, duree_lisible } from '@/utils/laboratoire-delais'

// LAB-001 : chronologie d'une ligne d'analyse (statut, jalons, événements) lue par la capacité laboratoire.
export const LIBELLES_EVENEMENTS = {
    prescription: 'Prescription',
    paiement: 'Paiement',
    prelevement: 'Prélèvement',
    reception: 'Réception au laboratoire',
    rejet: 'Rejet de l\'échantillon',
    debut_analyse: 'Début de la technique',
    fin_technique: 'Fin de la technique',   // LAB-009
    saisie: 'Saisie du résultat',
    validation: 'Validation et diffusion',
    rectification: 'Rectification',
    valeur_critique: 'Valeur critique signalée',
    non_conformite: 'Non-conformité',
    annulation: 'Annulation',
    reprise: 'Reprise des données existantes',
    incoherence: 'Incohérence journalisée',
    retour_saisie: 'Retour à la saisie',
    documents_ajoutes: 'Pièce jointe ajoutée',
    document_retire: 'Pièce jointe retirée'
}

// LAB-009 : délai affiché sur chaque jalon du parcours = durée depuis le jalon précédent (clés de parcours.durees)
export const DELAIS_JALONS = {
    paiement: 'demande_paiement_min',
    prelevement: 'paiement_prelevement_min',
    reception: 'prelevement_reception_min',
    technique: 'reception_technique_min',
    saisie: 'technique_saisie_min',
    validation: 'saisie_validation_min'
}

export const LIBELLES_ROLES = {
    prescripteur: 'Prescripteur',
    caisse: 'Caisse',
    prelevement: 'Prélèvement',
    systeme: 'Système',
    ROLE_MEDECIN: 'Médecin',
    ROLE_INFIRMIER: 'Infirmier',
    ROLE_TECH_SUP_LABO: 'Technicien de laboratoire',
    ROLE_MEDECIN_BIOLOGISTE: 'Médecin biologiste',
    ROLE_ADMINISTRATEUR: 'Administrateur'
}

export default {
    name: 'suivi-analyse',
    components: {},
    props: {
        demande: Object,
        toggler: Number
    },
    data() {
        return {
            is_loading: false,
            is_empty: false,
            is_error: false,
            msg_error: '',
            suivi: null,
            requete_courante: 0
        }
    },

    watch: {
        toggler() {
            this.charger()
        }
    },

    computed: {
        evenements() {
            return (this.suivi && Array.isArray(this.suivi.evenements)) ? this.suivi.evenements : []
        },

        titre() {
            if (this.suivi && this.suivi.analyse) {
                return this.suivi.analyse
            }
            return (this.demande && this.demande.nom) ? this.demande.nom : ''
        },

        // LAB-009 : parcours tracé du bon, de la demande du médecin à la disponibilité des résultats
        parcours() {
            return (this.suivi && this.suivi.parcours && Array.isArray(this.suivi.parcours.jalons)) ? this.suivi.parcours : null
        },

        jalons() {
            if (!this.parcours) {
                return []
            }
            const durees = this.parcours.durees || {}
            return this.parcours.jalons.map((jalon) => {
                const cle = Object.prototype.hasOwnProperty.call(DELAIS_JALONS, jalon.cle) ? DELAIS_JALONS[jalon.cle] : null
                const minutes = cle && durees[cle] !== undefined ? durees[cle] : null
                return Object.assign({}, jalon, { delai: minutes === null ? '—' : duree_lisible(minutes) })
            })
        },

        lignes_parcours() {
            return (this.parcours && Array.isArray(this.parcours.lignes)) ? this.parcours.lignes : []
        },

        chronologie() {
            const jalons = this.jalons.map(jalon => ({
                key: 'jalon-' + jalon.cle, etape: jalon.libelle, statut: !jalon.at ? 'À venir' : (jalon.detail === 'En cours' ? 'En cours' : 'Effectué'),
                par: jalon.par || '—', at: jalon.at, fin_at: jalon.fin_at, detail: jalon.detail || '', delai: jalon.delai
            }))
            const correspondances = { prescription: 'demande', paiement: 'paiement', prelevement: 'prelevement', reception: 'reception', debut_analyse: 'technique', fin_technique: 'technique', saisie: 'saisie', validation: 'validation' }
            const datesJalons = {}
            this.jalons.forEach(jalon => { if (jalon.at) datesJalons[jalon.cle] = true })
            const autres = this.evenements.filter(evenement => !datesJalons[correspondances[evenement.type]]).map(evenement => ({
                key: 'evenement-' + evenement.id, etape: this.libelle_evenement(evenement.type), statut: evenement.vers_statut_libelle || 'Effectué',
                par: evenement.acteur_nom || '—', at: evenement.occurred_at, fin_at: null, detail: evenement.motif || '', delai: '—'
            }))
            return jalons.concat(autres).sort((a, b) => {
                if (!a.at) return b.at ? 1 : 0
                if (!b.at) return -1
                return String(a.at).localeCompare(String(b.at))
            })
        }
    },

    mounted() {

    },

    methods: {
        charger() {
            const demande_id = (this.demande && this.demande.demande_id) ? this.demande.demande_id : 0
            this.suivi = null
            this.is_error = false
            this.msg_error = ''
            this.is_empty = false
            if (!demande_id) {
                this.is_empty = true
                return Promise.resolve()
            }
            this.is_loading = true
            const requete = ++this.requete_courante
            return store_laboratoire.getSuiviDemande(demande_id).then((response) => {
                if (requete !== this.requete_courante) {
                    return
                }
                if (response && response.success && response.data) {
                    this.suivi = response.data
                    this.is_empty = this.chronologie.length === 0
                } else {
                    this.is_empty = true
                }
                this.is_loading = false
            }).catch((error) => {
                if (requete !== this.requete_courante) {
                    return
                }
                this.is_loading = false
                this.is_error = true
                this.msg_error = (error && error.response && error.response.data && error.response.data.message)
                    ? error.response.data.message
                    : 'Le suivi du laboratoire est indisponible pour le moment.'
            })
        },

        // LAB-008 : délais calculés par la Clinique depuis les jalons
        duree(minutes) {
            return duree_lisible(minutes)
        },

        libelle_evenement(type) {
            return Object.prototype.hasOwnProperty.call(LIBELLES_EVENEMENTS, type) ? LIBELLES_EVENEMENTS[type] : type
        },

        libelle_role(role) {
            if (!role) {
                return ''
            }
            return Object.prototype.hasOwnProperty.call(LIBELLES_ROLES, role) ? LIBELLES_ROLES[role] : role
        },

        date_heure(value) {
            const parcours = this.parcours || {}
            return date_heure_zone(value, parcours.timezone || 'UTC', parcours.source_timezone || 'UTC') || 'Non renseignée'
        }
    }
}
